module.exports = __webpack_public_path__ + "img/H5-01.eecfb8ed.png";